export default __webpack_public_path__ + "static/media/no-coloured-manager.10c61724.svg";